import React from 'react'

function NoDataAccessToggle({ params, setParams }) {
  return (
    <div className="form-check form-switch mt-1">
      <input
        className="form-check-input"
        type="checkbox"
        id="noDataAccess"
        checked={params.noDataAccess}
        onChange={() =>
          setParams({ ...params, noDataAccess: !params.noDataAccess })
        }
      />
      <label className="form-check-label" htmlFor="noDataAccess">
        No Data Access
      </label>
    </div>
  )
}

export default NoDataAccessToggle
